import { Command } from 'commands/Commands';

export class RemoveBusinessFile extends Command {
  type: string = 'RemoveBusinessFile';
  constructor(public newValue: string) {
    super(newValue);
  }
  priority: number = 100;
}
